import { IHistoryItem } from 'entities/History/History.models';
import { INote } from 'entities/Notes/Note.models';

export const getFullHistory = (eventHistory: IHistoryItem[], notes: INote[]): (IHistoryItem | INote)[] => {
  // @ts-ignore
  return eventHistory.concat(notes).sort((a, b) => b.createdAt.localeCompare(a.createdAt));
};
